<ui-radio-group [ngModel]="timeFilter$ | async" [horizontal]="true" (ngModelChange)="onTimeFilterChange($event)" uiSize="default">
  <label ui-radio-button uiValue="week">7D</label>
  <label ui-radio-button uiValue="month">1M</label>
  <label ui-radio-button uiValue="three-months">3M</label>
  <label ui-radio-button uiValue="year">1Y</label>
  <label ui-radio-button uiValue="all-time">ALL</label>
</ui-radio-group>
